import { render, staticRenderFns } from "./AccountRequestsPage.vue?vue&type=template&id=f2f4312e&scoped=true"
import script from "./AccountRequestsPage.vue?vue&type=script&lang=ts"
export * from "./AccountRequestsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f4312e",
  null
  
)

export default component.exports